import { getSelectorRoot } from 'utils/selectors';

const getMatchStreamingStore = getSelectorRoot('matchStreaming');

export const getIsTheatreMode = getMatchStreamingStore('isTheatreMode');

export const getIsTheatreModePrev = getMatchStreamingStore('isTheatreModePrev');

export const getMatchStreamingGameData = getMatchStreamingStore('data');

export const getMatchStreamingUrls = getMatchStreamingStore('streamUrls');

export const getIsCanFixMSOnTop = getMatchStreamingStore('isCanFixOnTop');

export const getIsStreamerLandscape = getMatchStreamingStore('isLandscape');

export const getMatchStreamingViewMode = getMatchStreamingStore('viewMode');

export const getMatchStreamingType = getMatchStreamingStore('streamingType');

export const getIsMatchStreamingVisible = getMatchStreamingStore('isVisible');

export const getMatchStreamingSettings =
  getMatchStreamingStore('streamSettings');

export const getMatchStreamingPrevViewMode =
  getMatchStreamingStore('prevViewMode');
export const getMatchStreamingLiveStreamInfo =
  getMatchStreamingStore('liveStreamInfo');

export const getMatchStreamingContainerInfo =
  getMatchStreamingStore('containerInfo');

export const getMatchStreamingMountingInfo = getMatchStreamingStore(
  'isHolderPositionApplied'
);

export const getIsMSTheatreModeAvailable = getMatchStreamingStore(
  'isTheatreModeAvailable'
);
export const getMatchStreamingChannelInfo = getMatchStreamingStore(
  'streamingChannelInfo'
);
export const getIsMatchStreamingChannelsAvailable = getMatchStreamingStore(
  'isChannelsAvailable'
);

export const getIsStreamingPreviewUnavailable = getMatchStreamingStore(
  'isPreviewUnavailable'
);

export const getDisableMatchStreamingType = getMatchStreamingStore(
  'streamingTypeDisable'
);

export const getGamePreviewNotAvailable = getMatchStreamingStore(
  'gamePreviewNotAvailable'
);
